const wsrvLoader = ({ src, width, quality }: { src: string; width: number; quality?: number }) => {
  // Local images (relative paths) can't go through wsrv.nl — serve directly
  if (src.startsWith("/")) {
    return src
  }

  const url = new URL("https://wsrv.nl/")
  url.searchParams.set("url", src)
  url.searchParams.set("w", width.toString())
  url.searchParams.set("q", (quality || 75).toString())
  url.searchParams.set("output", "webp")
  return url.toString()
}
export default wsrvLoader
